(function () {
  'use strict';

  const ESSENTIAL_VARIANTS = [
    '54539996791122', // Chorizo
    '54539996823890', // Salchichón
    '54539996856658'  // Picante
  ];

  const PRIME_VARIANT = '54541349454162';

  const GIFT_VARIANT = '54539600265554';

  let syncingGift = false;
  let syncTimeout;

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('No se pudo consultar el carrito');
    }

    return response.json();
  }

  function hasEssential(cart) {
    return cart.items.some(function (item) {
      return ESSENTIAL_VARIANTS.includes(String(item.variant_id));
    });
  }

  function hasPrime(cart) {
    return cart.items.some(function (item) {
      return String(item.variant_id) === PRIME_VARIANT;
    });
  }

  function getGiftLine(cart) {
    return cart.items.find(function (item) {
      return String(item.variant_id) === GIFT_VARIANT;
    });
  }

  async function addGift() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(GIFT_VARIANT),
            quantity: 1
          }
        ]
      })
    });
  }

  async function removeGift(lineKey) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    });
  }

  async function syncGift() {
    if (syncingGift) return;

    syncingGift = true;

    try {
      const cart = await getCart();

      const eligible = hasEssential(cart) && hasPrime(cart);
      const gift = getGiftLine(cart);

      if (eligible && !gift) {
        await addGift();
      }

      if (!eligible && gift) {
        await removeGift(gift.key);
      }
    } catch (error) {
      console.error('Error en regalo La Vuelta al Ibérico:', error);
    } finally {
      syncingGift = false;
    }
  }

  function scheduleSync() {
    clearTimeout(syncTimeout);

    syncTimeout = setTimeout(function () {
      syncGift();
    }, 400);
  }

  /*
   * Detectamos cuando el tema modifica el carrito.
   */
  const originalFetch = window.fetch;

  window.fetch = function () {
    const args = arguments;
    const url = args[0] && args[0].url
      ? args[0].url
      : String(args[0]);

    return originalFetch.apply(this, args).then(function (response) {

      if (
        !syncingGift &&
        (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear')
        )
      ) {
        scheduleSync();
      }

      return response;
    });
  };

  /*
   * Comprobación inicial.
   */
  document.addEventListener('DOMContentLoaded', function () {
    scheduleSync();
  });

  /*
   * También comprobamos cuando Shopify/tema actualiza el carrito.
   */
  document.addEventListener('cart:updated', scheduleSync);
  document.addEventListener('cart:refresh', scheduleSync);

})();